import { render, staticRenderFns } from "./index.vue?vue&type=template&id=40d035e7&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d035e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40d035e7')) {
      api.createRecord('40d035e7', component.options)
    } else {
      api.reload('40d035e7', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=40d035e7&scoped=true", function () {
      api.rerender('40d035e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/canteen-product/back/index.vue"
export default component.exports